import Vue from "vue";
import Router from "vue-router";
import Store from "./store";
import Login from "./views/Account/Login.vue";
import Register from "./views/Account/Register.vue";
import PasswordRequestReset from "./views/Account/PasswordRequestReset.vue";
import PasswordChange from "./views/Account/PasswordChange.vue";

Vue.use(Router);

export const router = new Router({
	mode: "history",
	routes: [
		// {
		// 	path: "/",
		// 	alias: ["/home"],
		// 	name: "home",
		// 	component: Home,
		// },

		{
			path: "/login",
			name: "login-page",
			component: Login,
		},
		{
			path: "/register",
			name: "register-page",
			component: Register,
		},
		{
			path: "/password-request-reset",
			name: "password-request-reset-page",
			component: PasswordRequestReset,
		}, {
			path: "/password-change/:userId/:token",
			name: "password-change-page",
			component: PasswordChange,
		},
		{
			path: "/confirm/:code",
			name: "confirm-page",
			component: () => import("./views/Account/ConfirmEmail.vue"),
		},
		{
			path: "/profile",
			name: "profile",
			component: () => import("./views/Profile.vue"),
			meta: {
				requiresAuth: true
			},
		},
		{
			path: "/my-events",
			name: "my-events",
			component: () => import("./components/profile/MyEvents.vue"),
			meta: {
				requiresAuth: true
			},
		},
		// {
		// 	path: "/admin",
		// 	name: "admin",
		// 	// lazy-loaded
		// 	component: () => import("./views/BoardAdmin.vue"),
		// 	meta: { requiresAuth: true },
		// },
		// {
		// 	path: "/mod",
		// 	name: "moderator",
		// 	// lazy-loaded
		// 	component: () => import("./views/BoardModerator.vue"),
		// 	meta: { requiresAuth: true },
		// },
		// {
		// 	path: "/user",
		// 	name: "user",
		// 	// lazy-loaded
		// 	component: () => import("./views/BoardUser.vue"),
		// 	meta: { requiresAuth: true },
		// },
		{
			path: "/events",
			alias: ["/", "/home"],
			name: "events",
			component: () => import("./views/EventsGrid.vue"),
		},
		{
			path: "/events/add",
			name: "event-add",
			component: () => import("./components/admin/EditEvent.vue"),
			meta: {
				requiresAuth: true,
				roles: ["ROLE_ADMIN"]
			},
		},
		{
			path: "/events/:id",
			name: "event-details",
			component: () => import("./views/Event.vue"),
		},
		{
			path: "/events/:id/edit",
			name: "event-edit",
			component: () => import("./components/admin/EditEvent.vue"),
			meta: {
				requiresAuth: true,
				roles: ["ROLE_ADMIN"]
			},
		},
		{
			path: "/events/:id/stats",
			name: "event-stats",
			component: () => import("./components/admin/EventStats.vue"),
			meta: {
				requiresAuth: true,
				roles: ["ROLE_ADMIN"]
			},
		},
		{
			path: "/404",
			name: "404-page",
			alias: "*",
			component: () => import("./views/404.vue"),
		},
	],
	linkActiveClass: "active",
	linkExactActiveClass: "exact-active",
});

router.beforeEach(async (to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		let loginStatus = await Store.dispatch("user/loginStatus"); //api
		if (loginStatus === undefined || !loginStatus.success) {
			next({
				name: "login-page",
				params: {
					redirect: to.fullPath
				},
			});
		} else {
			const user = await Store.dispatch("user/getProfile");
			if (to.meta.roles) {
				if (to.meta.roles.some((role) => user.roles.includes(role))) {
					next();
				} else {
					next("/404-page");
				}
			} else {
				next();
			}
		}
	} else {
		next();
	}
});
